module.exports = __webpack_public_path__ + "static/media/headerImg1_mobil.6c9a0ac6.jpg";